import { render, staticRenderFns } from "./PayoutsTable.vue?vue&type=template&id=795a9435&scoped=true&"
import script from "./PayoutsTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a9435",
  null
  
)

export default component.exports